
import { useRef } from 'react';
import { IconSearch } from '../Icons';
import styles from './SearchFilter.module.css';

/**
 * Exemplo de uso:
 * const ref = useRef();
 * ref.current.getCurrentFilterName();
 */
export const SearchFilter = (props) => {

    const refInput = useRef();
    const focusInput = () => {
        refInput?.current?.focus()
    }
    return (
        <>
            <section className={styles.ContainerSearch} >
                <IconSearch onClick={focusInput} color='var(--cor_tooMe)' />
                <input ref={refInput} {...props} type='search' />
            </section>
        </>
    );
}
